import type { BlogPost } from '../types'

const post: BlogPost = {
  title: 'The Marshmallow Test',
  slug: 'the-marshmallow-test',
  category: 'The Marshmallow Test',
  date: '2025-05-16',
  image: '',
  excerpt: 'The Marshmallow Test was an experiment at Stanford in the late 1960s & early 70s that studied self-control vs. instant gratification in children.',
  body: `The Marshmallow Test was an experiment at Stanford in the late 1960s & early 70s that studied self-control vs. instant gratification in children. Here's the setup:

A child is given a marshmallow and is given a choice: they could eat the marshmallow now, or if they wait for a bit, they could have two. Some kids ate the marshmallow, some waited and got two.

Whether or not the kid ate the marshmallow immediately or not became a pretty reliable predictor of how the person would fare through life: academics, social skills, and overall success.

Do you have trouble deferring gratification for a bigger goal? If so, you're not alone. By identifying your propensity for eating the marshmallow brings you to a decision.

It's okay to eat it now. Just know you're limiting the future's possibilities. Count the cost and own the implications.

Or… Do something about it. Talk to your coach. Look at the gap between your values and your habitual behaviors. Make some plans. Be accountable to your vision. And make some changes.`,
}

export default post
